export default __webpack_public_path__ + "6f57294bdb45623e86001abf7b0feedc.woff";